import _ from "lodash"
import { modulo } from "../../../views/graph/utils"
import { Line, CappedLine, DownwardCurve, UpwardCurve } from "./"

export default class SVGPointConverter {
  constructor(points) {
    this.points = points
  }

  toSVGCommand() {
    const commands = this.pointsToSVGCommands(this.points)
    const augmented = this.augmentSVGCommands(commands)

    return augmented.map(c => c.toSVGCommand()).join(" ")
  }

  pointsToSVGCommands(points) {
    const commands = _.map(points, (point, index) => {
      const source = point
      const target = points[index + 1]

      if (!target) {
        return
      }

      switch (this.getSVGCommand(source, target)) {
        case "line":
          return new Line(source, target)
        case "cappedLine":
          return new CappedLine(source, target)
        case "downwardCurve":
          return new DownwardCurve(source, target)
        case "upwardCurve":
          return new UpwardCurve(source, target)
      }
    })

    return _.compact(commands)
  }

  getSVGCommand(source, target) {
    const fudgeFactor = 2
    const xModulo = modulo(source.x, target.x)
    const yModulo = modulo(source.y, target.y)

    if (target.kind == "event") {
      return "cappedLine"
    } else if (
      target.kind == "virtual" ||
      xModulo <= fudgeFactor ||
      yModulo <= fudgeFactor
    ) {
      return "line"
    } else if (
      target.kind == "merge-point" ||
      source.kind == "condition-label"
    ) {
      return "upwardCurve"
    } else if (source.kind == "condition-button") {
      return "upwardCurve"
    } else {
      return "downwardCurve"
    }
  }

  augmentSVGCommands(svgCommands) {
    _.forEach(svgCommands, (command, index) => {
      const nextCommand = svgCommands[index + 1]

      if (!nextCommand) {
        return command
      }

      // We're coming from a curve to a straight line which will draw a 90
      // degree angle. Augment that by inserting a curve at the join point.
      if (
        (command instanceof DownwardCurve &&
          nextCommand instanceof Line &&
          nextCommand.isVertical()) ||
        (command instanceof DownwardCurve && nextCommand instanceof CappedLine)
      ) {
        const curveGap = 30
        const isRightCurve = command.source.x > nextCommand.source.x
        const targetX = isRightCurve
          ? command.target.x + curveGap
          : command.target.x - curveGap

        command.target = {
          x: targetX,
          y: command.target.y - curveGap / 2
        }

        // Move next point a bit down to leave space for the smoother curve
        nextCommand.source.y = nextCommand.source.y + curveGap / 2
        // Add a curve to meet with the next point
        svgCommands.splice(
          index + 1,
          0,
          new UpwardCurve(command.target, nextCommand.source)
        )
      }
    })

    return svgCommands
  }
}
